
import {createLoadableList} from 'helpers/context'

const homework = {
    homeworks: createLoadableList(),
    studentHomeworkStatus: createLoadableList(),
    review: {from: undefined, query: undefined},
    createHomework: {open: false, editing: false, editState: undefined},
    deleteHomework: {open: false, homework: undefined}
}

export {homework as default}
  
  
